import { defineStore } from 'pinia';

export const useMobileMenuStore = defineStore(
    'mobileMenu',
    {
        state: () => ({
            navigationItems: [],
            navigationTitle: null,
            isSearchVisible: false,
        }),
        actions: {
            addNavigationItem(item) {
                this.navigationItems.push(item);
            },
            setNavigationTitle(title) {
                this.navigationTitle = title;
            },
            setNavigationItems(items = []) {
                this.navigationItems = items;
            },
            toggleSearch() {
                this.isSearchVisible = !this.isSearchVisible;
            },
        },
    });